import {Injectable} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {CONSTANT} from '../constants/constant';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor(private cookieService: CookieService) {}

  getAuthorizationId() {
    return this.cookieService.get(CONSTANT.cookie.login.authorizationId);
  }
  setAuthorizationId(payLoad: string) {
    this.cookieService.set(CONSTANT.cookie.login.authorizationId, payLoad);
  }

  getAuthNToken() {
    return this.cookieService.get(CONSTANT.cookie.login.authN);
  }

  setAuthNToken(payload: string) {
    this.cookieService.set(CONSTANT.cookie.login.authN, payload);
  }

  getAuthZToken() {
    return this.cookieService.get(CONSTANT.cookie.login.authZ);
  }

  setAuthZToken(payload: string) {
    this.cookieService.set(CONSTANT.cookie.login.authZ, payload);
  }

  setDeepLink() {
    sessionStorage.setItem(CONSTANT.deeplink.key, CONSTANT.deeplink.url);
  }

  setLanguage(language: string) {
    this.cookieService.set(CONSTANT.cookie.language.default, language);
    this.cookieService.set(CONSTANT.cookie.language.externalSignIn, language);
  }
  getLanguage(checkSignIn: boolean = false) {
    // Ensures language cookie access compatibility with external sign-in cookie name, and default cookie name 
    const cookieName = checkSignIn
      ? CONSTANT.cookie.language.externalSignIn
      : CONSTANT.cookie.language.default;
    return this.cookieService.get(cookieName);
  }
}
